import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  CanActivate,
  CanActivateChild
} from "@angular/router";
import { Observable } from "rxjs";
import { MsalGuard } from "@azure/msal-angular";

@Injectable({
  providedIn: "root"
})
export class IsAuthenticatedGuard implements CanActivate, CanActivateChild {

  constructor(private _authGuard: MsalGuard) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean | UrlTree> | boolean {
    return this._canActivate(route, state);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean | UrlTree> | boolean {
    return this._canActivate(route, state);
  }

  protected _canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean | UrlTree> | boolean {
    const canActivate = this._authGuard.canActivate(route, state);
    if (typeof canActivate === "undefined") {
      return false;
    }
    return canActivate;
  }

}
